<div class="invite-actions">
  <button mat-raised-button color="primary" (click)="send()" [disabled]="isButtonDisabled">
    <mat-icon>forward_to_inbox</mat-icon> {{ buttonLabel }}
  </button>
  <app-benefit-flyers [teamId]="teamId" [compact]="true"></app-benefit-flyers>
</div>
